import React, { useEffect } from "react";
import classes from "./Profile.module.css";
import Layout from "../component/Layout";
import SubLayout from "../component/SubLayout";
import Header from "../component/Header";
import BottomNavbar from "../component/BottomNavbar";
import Container from "../component/Container";
import {
  FaFutbol,
  FaArrowRightFromBracket,
  FaPen,
  FaArrowLeft,
} from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { removeUserDetails } from "../store/slices/userSlice";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { getProfileApi, unsubApi } from "../http/http";
import SmallLoader from "../component/SmallLoader";
import { toast } from "react-toastify";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { userDetails } = useSelector((state) => state.persisted?.userSlice);
  const [loading, setLoading] = useState(false);
  const [flow, setFlow] = useState("");

  const [profile, setProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        setProfileLoading(true);
        const response = await getProfileApi(userDetails?.token);
        setProfile(response?.data);
        setProfileLoading(false); // this line is missing please add this
        setLoading(false);
      } catch (error) {
        setProfileLoading(false);
        toast.error(
          error?.response?.data?.error?.error ||
            error?.response?.error?.error ||
            error?.response?.error ||
            "Something Went Wrong!",
        );
      }
    };

    fetchUserProfile();
  }, []);

  const logoutHandler = () => {
    dispatch(removeUserDetails());
    navigate("/");
  };

  const unsubHandler = async () => {
    try {
      setLoading(true);
      const response = await unsubApi(
        { action: 2, serviceId: 1 },
        userDetails?.token,
      );
      dispatch(removeUserDetails());
      setLoading(false);
      navigate("/");
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <Layout>
      <SubLayout>
        <Header active={4} />
        {flow === "UNSUB" ? (
          <Container className={classes.container}>
            <p className={classes.unsub_text}>{t("UnsubDesc")}</p>
            <button
              type="button"
              onClick={unsubHandler}
              disabled={loading}
              className={classes.unsub_btn}
            >
              {loading ? (
                <SmallLoader style={{ border: "5px solid #fff" }} />
              ) : (
                t("Unsub")
              )}
            </button>
            <button
              type="button"
              className={classes.back_button}
              onClick={() => setFlow("")}
            >
              <FaArrowLeft className={classes.back_icon} /> {t("26")}
            </button>
          </Container>
        ) : (
          <Container style={{ gap: "30px" }}>
            <div className={classes.profile_section}>
              <p className={classes.profile_header}>{t("178")}</p>
              {profileLoading ? (
                <SmallLoader />
              ) : (
                <div className={classes.profile_sub_section}>
                  <div className={classes.profile_avatar}>
                    <img
                      src={profile?.image ?? "/assets/images/dummy.png"}
                      alt={profile?.name ?? t("181")}
                      className={classes.avatar_image}
                    />
                  </div>
                  <div className={classes.profile_details}>
                    <p className={classes.profile_text}>
                      {t("179")} {profile?.name ?? t("181")}
                    </p>
                    <p className={classes.profile_text}>
                      {t("180")} {profile?.id}
                    </p>
                  </div>
                </div>
              )}
            </div>

            <button
              type="button"
              className={classes.list_item_container}
              onClick={() => navigate("/edit-profile")}
            >
              <FaPen className={classes.edit_icon} />
              <p className={classes.list_item_text}>{t("117")}</p>
            </button>

            <button
              type="button"
              className={classes.list_item_container}
              onClick={() => navigate("/my-matches")}
            >
              <FaFutbol className={classes.my_matches_icon} />
              <p className={classes.list_item_text}>{t("118")}</p>
            </button>

            <button
              type="button"
              className={classes.list_item_container}
              onClick={() => setFlow("UNSUB")}
            >
              <FaArrowRightFromBracket className={classes.logout_icon} />
              <p className={classes.list_item_text}>{t("Unsub")}</p>
            </button>

            <button
              type="button"
              className={classes.list_item_container}
              onClick={logoutHandler}
            >
              <FaArrowRightFromBracket className={classes.logout_icon} />
              <p className={classes.list_item_text}>{t("119")}</p>
            </button>
          </Container>
        )}
      </SubLayout>
      {/* <BottomNavbar active={4} /> */}
    </Layout>
  );
};

export default Profile;
